import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { MatButtonModule } from '@angular/material/button'
import { MatCardModule } from '@angular/material/card'
import { MatIconModule } from '@angular/material/icon'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { MatTooltipModule } from '@angular/material/tooltip'
import { PipesModule } from '@mmx/pipes'
import { DirectivesModule } from '@mmx/shared'
import { TranslateModule } from '@ngx-translate/core'

import { AppointmentDetailsFactModule } from '../appointment-details-fact'
import { AppointmentCardComponent } from './appointment-card.component'

@NgModule({
  imports: [
    AppointmentDetailsFactModule,
    CommonModule,
    DirectivesModule,
    FlexLayoutModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    MatProgressBarModule,
    MatTooltipModule,
    PipesModule,
    TranslateModule,
  ],
  exports: [
    AppointmentCardComponent,
  ],
  declarations: [
    AppointmentCardComponent,
  ],
  providers: [],
})
export class AppointmentCardModule { }
